module.exports = __webpack_public_path__ + "static/img/icon_gonggao.3764ce2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_gonggao.gif
// module id = PeoR
// module chunks = 1